import type { UserRole } from "@the-drop/types";
import { getDispensaryApiBaseUrl } from "./api-base";

export type MeUser = {
  clerkUserId: string;
  platformUserId: string;
  /** All roles for this account (multi-role supported). */
  roles: UserRole[];
  /** Staff-first legacy summary; prefer `roles.includes(...)`. */
  role: UserRole;
  dispensaryId?: string;
  transporterId?: string;
  customerId?: string;
};

export type MeResponse = { user: MeUser };

export async function fetchMe(getToken: () => Promise<string | null>): Promise<MeResponse> {
  const token = await getToken();
  if (!token) {
    throw new Error("not_signed_in");
  }
  const base = getDispensaryApiBaseUrl();
  const path = "/api/v1/me";
  const url = base ? `${base}${path}` : path;
  const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
  if (!res.ok) {
    throw new Error(`me_http_${res.status}`);
  }
  return (await res.json()) as MeResponse;
}
